import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store.types';

export interface NotificationState {
    isVisible: boolean;
    text: string;
}

export const initialState: NotificationState = {
    isVisible: false,
    text: '',
};

const notification = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        showNotification: (state, action: PayloadAction<string | undefined>) => {
            state.isVisible = true;
            state.text = action.payload ?? '';
        },
        hideNotification: (state) => {
            state.isVisible = false;
            state.text = '';
        },
        updateNotificationText: (state, action: PayloadAction<string>) => {
            state.text = action.payload;
        },
    },
});

export const { showNotification, hideNotification, updateNotificationText } = notification.actions;

const selectNotificationState = (state: RootState) => state.notification;

export const selectIsVisible = createSelector(selectNotificationState, (state) => state.isVisible);
export const selectText = createSelector(selectNotificationState, (state) => state.text);

export default notification.reducer;
